import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AppComponent} from "../../app.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DialogCanvasComponent} from "../dialog-canvas/dialog-canvas.component";
import {SharedDataService} from "../../services/shared-data.service";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import {
  Calendar,
  CalendarOptions,
  EventApi,
  EventClickArg,
  FullCalendarComponent,
  FullCalendarModule
} from "@fullcalendar/angular";
import interactionPlugin from "@fullcalendar/interaction";
import {SubscriptionLike} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AppEvent} from "../../objects/appEvent";

@Component({
  selector: 'app-big-calendar-container',
  templateUrl: './big-calendar-container.component.html',
  styleUrls: ['./big-calendar-container.component.scss']
})
export class BigCalendarContainerComponent implements OnInit {
  @ViewChild('calendar', { static: false }) public calendarComponent: FullCalendarComponent;
  @ViewChild('calendarContainer') public calendarContainer: ElementRef<HTMLElement>;

  public componentForm: FormGroup = new FormGroup({});
  public calendarPicker: FormControl = new FormControl('');
  public calendarApi: Calendar;
  calendarOptions: CalendarOptions;
  calendarDataLoaded: boolean = true;
  displayResources: object[];
  _selectedDate: Date = new Date();
  public get selectedDate(): Date {
    return this._selectedDate;
  }
  public set selectedDate(value: Date) {
    this._selectedDate = value;
    console.log('this._selectedDate',this._selectedDate)
    this.calendarApi.gotoDate(this._selectedDate.getTime())
    this.loadEvents()
  }

  public readonly allCalendarsIdx: number = -1; //artificial "All calendars" option
  public get isCombinedView(): boolean {
    return this._selectedGroupCalendarIdx === this.allCalendarsIdx;
  }

  _selectedGroupCalendarIdx: number = 0;
  public get selectedGroupCalendarIdx(): number {
    return this._selectedGroupCalendarIdx;
  }
  public set selectedGroupCalendarIdx(value: number) {
    if(this._selectedGroupCalendarIdx == value) {
      return;
    }
    this._selectedGroupCalendarIdx = value;
    this.application.bigCalendarCombinedView = this.isCombinedView; //no single calendar to create events in
    this.setResourcesColumns()
    this.loadEvents()
  }

  private selectedGroupCalendar: object;
  private dataLoader: SubscriptionLike;
  private sharedEventSubscription: SubscriptionLike;
  private readonly nonEditableTypes: string[] = ['booking_cancel','booking_refund'];
  constructor(public application: AppComponent,
              public dialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    FullCalendarModule.registerPlugins([
      resourceTimeGridPlugin
    ])

    this.selectedGroupCalendarIdx = 0;
    this.componentForm.addControl('calendarPicker', this.calendarPicker);
    this.calendarPicker.setValue(this.selectedGroupCalendarIdx)

    // this.displayResources = [
    //   { id: 'a', title: 'Room A' },
    //   { id: 'b', title: 'Room B'},
    //   { id: 'c', title: 'Room C' },
    //   // { id: 'd', title: 'Room D' },
    //   // { id: 'e', title: 'Room A' },
    //   // { id: 'f', title: 'Room B'},
    //   // { id: 'g', title: 'Room C' },
    //   // { id: 'h', title: 'Room D' },
    //   { id: 'i', title: 'Room D' }
    // ];
    this.calendarOptions = {
      plugins: [ interactionPlugin, resourceTimeGridPlugin ],
      initialView: 'resourceTimeGridDay',
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      resources: [],
      //resources: this.displayResources,
      nowIndicator: true,
      headerToolbar: false,
      height: '100%',
      // headerToolbar: {
      //   //left: 'prev,today,next',
      //   left: 'prev',
      //   center: 'title',
      //   //right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      //   right: 'next'
      // },
      // buttonText: {
      //   today: 'Today'
      // },

      firstDay: 1, // 1 Monday
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        daysOfWeek: [ 0, 1, 2, 3, 4, 5, 6 ], // Monday - Thursday

        // startTime: '08:00', // a start time
        // endTime: '23:20', // an end time
        startTime: this.application.account.calendars[0]['parsed_params']['start_hour'], // a start time
        endTime: this.application.account.calendars[0]['parsed_params']['end_hour'], // an end time
      },
      displayEventTime: false,
      locale: 'uk',
      // slotDuration: '00:40:00',
      // slotMinTime: '08:00:00',
      // slotMaxTime: '23:20:00',
      slotDuration: AppComponent.convertSecondsToHMS(parseInt(this.application.account.calendars[0]['parsed_params']['duration'])/2),
      slotMinTime: this.application.account.calendars[0]['parsed_params']['start_hour']+':00',
      slotMaxTime: this.application.account.calendars[0]['parsed_params']['end_hour']+':00',

      allDaySlot: false,
      titleFormat: { month: 'long', day: 'numeric' },
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: 'short'
      },
      initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
      weekends: true,
      editable: false, // disables event dragging + resizing
      selectable: true,
      selectMirror: false,
      dayMaxEvents: true,
      eventClick: this.handleEventClick.bind(this),
      //dateClick: this.slotClick.bind(this),
      select: this.slotsSelect.bind(this),
      //eventsSet: this.handleEventsSet.bind(this),
      //eventAdd:  this.handleEventAdd.bind(this),
      /* you can update a remote database when these fire:
      eventAdd:
      eventChange:
      eventRemove:
      */
      eventDidMount: function(info) {
        //console.log('info.event.extendedProps',info.event.extendedProps);
      },
      eventContent: function(arg) { //re-render title as HTML
        let divEl = document.createElement('div')
        divEl.innerHTML = arg.event.title
        let arrayOfDomNodes = [ divEl ]
        return { domNodes: arrayOfDomNodes }
      },
      eventMouseEnter: function (calEvent) {
        // console.log('aaaa',calEvent.el.offsetWidth)
        // console.log(calEvent.el)

        //find resource column where event renderers are attached and attach hovered content
        const attachColumnEl = document.querySelectorAll('[data-resource-id="'+calEvent.event.extendedProps['resourceId']+'"]')[1].childNodes[0];

        const displayGrid = document.getElementsByClassName('fc-scroller-harness-liquid')[0];
        const displayGridContent = displayGrid['childNodes'][0]; //scroll rendered here
        const verticalScrollSize = displayGridContent['offsetWidth'] - displayGridContent['clientWidth'];
        const timeAxis = document.getElementsByClassName('fc-timegrid-axis')[0];
        const resourcesList = this.getOption('resources');
        const resourceTypicalItemWidth = (displayGridContent['offsetWidth']-timeAxis['offsetWidth']-verticalScrollSize)/resourcesList.length;
        const currentResourceIdx = resourcesList.findIndex(resource => resource['id'] == calEvent.event.extendedProps['resourceId'])

        const calEventParent = calEvent.el.parentElement;
        //const attachColumnElWidth = document.querySelectorAll('[data-resource-id="'+calEvent.event.extendedProps['resourceId']+'"]')[1].firstElementChild[0].offsetWidth;

        let popupEl = document.getElementById('hover-'+calEvent.event.id)
        if(!popupEl) {
          popupEl = document.createElement('div')
          popupEl.id = 'hover-'+calEvent.event.id;
          popupEl.className = 'hover-end background-global border-color-accent'
          displayGrid.appendChild(popupEl)
        }
        popupEl.style.display = 'block';

        popupEl.innerHTML = calEvent.event.extendedProps['hover_text']
        const miniSpace = 10;
        //horisontal popup positioning
        if(currentResourceIdx < resourcesList.length/2) {
          popupEl.style.left = 0+'px';
          popupEl.style.marginLeft = (timeAxis['offsetWidth']+(currentResourceIdx+1)*resourceTypicalItemWidth+miniSpace)+'px';
        } else {
          popupEl.style.right = 0+'px';
          popupEl.style.marginRight = ((resourcesList.length-currentResourceIdx)*resourceTypicalItemWidth+verticalScrollSize+miniSpace)+'px';
        }
        //vertical popup positioning
        if(parseInt(calEventParent.style.top) < 2/3*displayGridContent['offsetHeight']) {
          popupEl.style.top = parseInt(calEventParent.style.top)-displayGridContent['scrollTop']+'px';
        } else {
          popupEl.style.bottom = displayGridContent['offsetHeight']-parseInt(calEventParent.style.top)-calEventParent['offsetHeight']+displayGridContent['scrollTop']+'px';
        }
      },
      eventMouseLeave: function(calEvent) {
        let popupEl = document.getElementById('hover-'+calEvent.event.id);
        //element.remove();
        if(popupEl) popupEl.style.display = 'none';
      }
    };
    this.loadEvents();
    setTimeout(() => {
      this.calendarApi = this.calendarComponent.getApi();
      this.setResourcesColumns();
    })

    this.makeCalesndarCss();
    this.addSubscriptions();
  }

  private addSubscriptions() {
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.ADD_BASIC_SCHEDULE && this.calendarDataLoaded) {
          this.editBasicEvent(); //no item => create mode
        }
      });
  }

  ngOnDestroy() {
    if(this.dataLoader && !this.dataLoader.closed) {
      this.dataLoader.unsubscribe()
    }
    if(this.sharedEventSubscription && !this.sharedEventSubscription.closed) {
      this.sharedEventSubscription.unsubscribe()
    }
    this.application.bigCalendarCombinedView = false;
  }

  private setResourcesColumns() {
    const calendars = this.application.account.calendars ? this.application.account.calendars : [];
    this.selectedGroupCalendar = this.isCombinedView ? null : calendars[this.selectedGroupCalendarIdx];
    const shownCalendars = this.isCombinedView ? calendars : [this.selectedGroupCalendar];

    this.displayResources = [];
    shownCalendars.forEach(groupCalendar => {
      const calendarNumber = calendars.indexOf(groupCalendar)+1; //same numeration as the calendar picker
      groupCalendar['settings']['bookable_objects'].forEach(column => {
        let resource = {}
        resource['id'] = column['id']
        resource['title'] = calendarNumber+'. '+column['label']
        resource['order'] = this.displayResources.length //keep calendars grouped, fullcalendar sorts by id otherwise
        this.displayResources.push(resource);
      })
    })
    this.calendarApi.setOption('resourceOrder','order')
    this.calendarApi.setOption('resources',this.displayResources)
  }

  //which calendar an event belongs to, found through the court it sits on
  private calendarIdxOfEvent(eventItem: EventApi): number {
    if(!eventItem) {
      return this.selectedGroupCalendarIdx;
    }
    const resourceId = eventItem.extendedProps['resourceId'];
    const idx = this.application.account.calendars.findIndex(groupCalendar =>
      groupCalendar['settings']['bookable_objects'].some(column => column['id'] == resourceId));
    return idx > -1 ? idx : this.selectedGroupCalendarIdx;
  }

  private loadEvents() {
    if(this.dataLoader && !this.dataLoader.closed) { //cancel previous subscription
      this.dataLoader.unsubscribe()
    }
    let fromDate = this.selectedDate;
    let toDate = new Date();
    toDate.setTime(fromDate.getTime()+86400000);

    if(this.calendarApi) { //remove old events
      this.calendarApi.getEvents().forEach( event => {
        event.remove()
      })
    }

    this.calendarDataLoaded = false;
    this.dataLoader = this.application.apiService.getBookingData(
      fromDate.getFullYear()+'-'+(fromDate.getMonth()+1)+'-'+fromDate.getDate(),
      toDate.getFullYear()+'-'+(toDate.getMonth()+1)+'-'+toDate.getDate()
    ).subscribe(
      data => this.handleItems(data),
      error => this.handleItemsError(error))
  }
  public handleItems(data): void {
    this.calendarDataLoaded = true;
    console.log('handleItems',data)
    setTimeout(() => {
      // this.calendarApi = this.calendarComponent.getApi();
      // //this.calendarApi.setOption('height','100%'); // doesn't work
      // setTimeout(() => {
      //   this.calendarApi.setOption('height',this.calendarContainer.nativeElement.offsetHeight)
      // })

      data.forEach(bookingEvent => {
        //bookingEvent.extendedProps['displayResources'] = this.displayResources;
        this.calendarApi.addEvent(bookingEvent);
        //setTimeout(() => { this.calendarApi.addEvent(bookingEvent); })
      })
    })
  }
  public handleItemsError(error): void {
    this.calendarDataLoaded = true;
    this.sharedDataService.pushNotification({ text: error.errMsg, type: 'error' })
  }

  handleEventClick(clickInfo: EventClickArg) {
    //console.log('clickInfo.event',clickInfo.event)
    if(this.nonEditableTypes.indexOf(clickInfo.event.extendedProps['schedule_type']) !== -1) {
      return; //cancelled and refunded bookings have nothing to edit
    }
    this.editBasicEvent(clickInfo.event)
  }

  public editBasicEvent(eventItem: EventApi = null): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: '50%',
      minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'basic-calendar-event',
        payload: {
          item: eventItem,
          controlled_event_type: 'unavailability', //temporary until booking_add submit will be supported
          calendarApi: this.calendarApi,
          calendarIDX: this.calendarIdxOfEvent(eventItem),
          selectedDate: this.selectedDate, //new events start on the day the grid is showing
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    //no reload here: the form updates the fullcalendar event in place (optimistic update)
  }

  slotsSelect(clickInfo: Object) {
    //console.log('clickInfo.event',clickInfo.event)
    clickInfo['slotsSelect'] = true;
    console.log('slotsSelect',clickInfo)

  }

  makeCalesndarCss() {
    //fullcalendar css-customization => https://fullcalendar.io/docs/v5/css-customization
    let fcCss = document.createElement('style');
    fcCss.innerHTML = '\n' +
      '      .fc-direction-ltr .fc-timegrid-col-events {\n' +
      '        margin: 0 5.5% 0 2px;\n' +
      '      \n}' +
      '      .fc .fc-event-main {\n' +
      '        overflow: hidden;' +
      '      }\n';
    fcCss.innerHTML+= '\n' +
      '      .fc .hover-end {' +
      '         border:1px solid;' +
      '         border-radius:4px;' +
      '         padding:12px;' +
      '         margin:0;text-align:center;position:absolute;z-index:100;' +
      '         width: max-content;' +
      '         max-width: 300px;' +
      '         font-size: 0.9em;' +
      '}\n';
    fcCss.innerHTML+= '\n' +
      '      .fc .fc-event {' +
      '         cursor: pointer;' +
      '}\n';
    document.getElementsByTagName('head')[0].appendChild(fcCss);
  }
}
